import { useEffect } from 'react';

interface GTMProps {
    gtmId: string; // GTM container id -- "GTM-XXXXXXX"
}

const GTM: React.FC<GTMProps> = ({ gtmId }) => {
    useEffect(() => {
        if (!gtmId) return;

        // Inject the GTM script
        const script = document.createElement('script');
        script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
        document.head.appendChild(script);

        // Inject the GTM noscript fallback
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
        document.body.appendChild(noscript);

        // Cleanup on unmount
        return () => {
            document.head.removeChild(script);
            document.body.removeChild(noscript);
        };
    }, [gtmId]);

    return null;
};

export default GTM;
